var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.376 0.267487C20.0279 0.74613 20.1961 1.70325 19.7516 2.40526L9.03736 19.3282C8.7978 19.7067 8.41394 19.9505 7.99052 19.9933C7.56692 20.036 7.14774 19.8733 6.84694 19.5494L0.418411 12.6264C-0.13947 12.0256 -0.13947 11.0515 0.418411 10.4507C0.976307 9.84981 1.88082 9.84981 2.43871 10.4507L7.64806 16.0607L17.391 0.67193C17.8354 -0.0300802 18.7242 -0.211156 19.376 0.267487Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.2ab8e996dd33a25fb7aaa17ea2ae409a.svg";
export { ForwardRef as ReactComponent };